
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiOwnShipRemoteY as ObiOwnShipRemoteYElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-own-ship-remote-y.js';
 
 
 

 
 export const ObiOwnShipRemoteY = createComponent({
   react: React,
   tagName: 'obi-own-ship-remote-y',
   elementClass: ObiOwnShipRemoteYElement,
   events: {
     
   }
  });
 
 